// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"448":"tabletDetail","472":"settings","565":"syncSchedule","924":"syncManual"}[chunkId] || chunkId) + "." + {"27":"ecdd1834","448":"7b422cad","452":"6ef2eeac","472":"544eae24","565":"91d8ba39","924":"d56bafb1"}[chunkId] + ".css";
};